<template>
    <el-card class="club-card" shadow="hover">
        <div class="club-header">
            <div class="club-types-container">
                <template v-if="Array.isArray(parsedClubTypes)">
                    <span v-for="(type, index) in parsedClubTypes" :key="index" class="club-type">
                        {{ type }}
                    </span>
                </template>
                <template v-else>
                    <span class="club-type">{{ club.type }}</span>
                </template>
            </div>
            <div class="students-count">
                <i class="el-icon-user"></i>
                <span>{{ club.student_count }}</span>
            </div>
        </div>
        
        <div class="club-info">
            <div class="name-section">
                <div class="club-avatar">
                    <img v-if="club.avatar" :src="club.avatar" :alt="club.name">
                    <div v-else class="avatar-placeholder">
                        {{ club.name.charAt(0).toUpperCase() }}
                    </div>
                </div>
                <h3>{{ club.name }}</h3>
            </div>
            

            <div class="advisers-section">

                <div class="section-title" v-if="club.advisors && club.advisors.length">
                    <span>Advisers:</span>
                    <template v-if="typeof club.advisors === 'string'">
                        <span>{{ club.advisors }}</span>
                    </template>
                    <template v-else>
                        <span v-for="(advisor, index) in club.advisors" :key="index">
                            {{ getAdvisorName(advisor) }}
                        </span>
                    </template>
                </div>

                <div v-else>
                    <div>
                        No Adviser
                    </div>
                </div>
            </div>
            <div>
                <div class="status-section">
                    <div v-if="!isJoined && isStudent">

                        <span v-if="club.status.stage == 'membership'" >{{club.status.status.charAt(0).toUpperCase() + club.status.status.slice(1)}} member</span>
                        <span v-if="club.status.stage == 'application'" >Application {{club.status.status}}</span>
                    </div>
                    <div v-if="isJoined && isStudent">
                        <span v-if="club.status.stage == 'membership'" >{{club.status.status.charAt(0).toUpperCase() + club.status.status.slice(1)}} member</span>
                    </div>
                </div>
                <div class="actions" >
                    <el-button v-if="!isStudent" type="primary" size="small" @click="$emit('assign-advisor', club)" style="margin-right: 10px;">Manage Advisers</el-button>
                    <el-button v-if="isJoined" type="primary" size="small" @click="$emit('view-detail', club)">Go to My Club</el-button>
                    <div v-if="!isJoined && isStudent">
                        <el-button v-if="club.status.stage == 'unjoined'" type="primary" size="small" @click="$emit('apply-join', club)">Apply to Join</el-button>
                        <el-button v-if="club.status.stage == 'membership'" type="primary" size="small" @click="$emit('view-detail', club)">Go to My Club</el-button>
                        <el-button v-if="club.status.stage == 'application'" type="primary" size="small" @click="$emit('view-application', club)">View Application</el-button>
                    </div>

                </div>
            </div>

            
        </div>
    </el-card>
</template>

<script>
export default {
    name: 'ClubCard',
    props: {
        club: {
            type: Object,
            required: true
        },
        isJoined: {
            type: Boolean,
            required: true
        },
        isStudent: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        parsedClubTypes() {
            if (!this.club.type) return null

            // If it's already an array, return it
            if (Array.isArray(this.club.type)) {
                return this.club.type
            }

            // If it's a string that looks like JSON array, parse it
            if (typeof this.club.type === 'string' && this.club.type.trim().startsWith('[')) {
                try {
                    const parsed = JSON.parse(this.club.type)
                    return Array.isArray(parsed) ? parsed : null
                } catch (e) {
                    return null
                }
            }

            // Otherwise return null to show as single type
            return null
        }
    },
    methods: {
        getAdvisorName(advisor) {
            if (!advisor) return ''

            // Check if advisor has contact_info nested structure
            if (advisor.contact_info) {
                const firstName = advisor.contact_info.contact_givenName || ''
                const lastName = advisor.contact_info.contact_lastName || ''
                return (firstName + ' ' + lastName).trim()
            }

            // Check if advisor has direct properties
            const firstName = advisor.contact_givenName || ''
            const lastName = advisor.contact_lastName || ''
            return (firstName + ' ' + lastName).trim()
        }
    }
}
</script>

<style scoped lang="scss">
.club-card {
    .club-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 15px;

        h3 {
            margin: 0;
            font-size: 18px;
        }

        .club-types-container {
            display: flex;
            flex-wrap: wrap;
            gap: 6px;
            flex: 1;
            margin-right: 10px;
        }

        .club-type {
            display: inline-block;
            font-size: 12px;
            color: #666;
            background: #f5f7fa;
            padding: 4px 10px;
            border-radius: 12px;
            border: 1px solid #e4e7ed;
            white-space: nowrap;
        }
    }

    .club-info {
        .name-section {
            display: flex;
            align-items: center;
            margin-bottom: 15px;

            h3 {
                margin: 0;
                margin-left: 15px;
                font-size: 18px;
            }

            .club-avatar {
                width: 50px;
                height: 50px;
                min-width: 50px;
                min-height: 50px;
                border-radius: 50%;
                overflow: hidden;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border: 2px solid #e6e8eb;
                    border-radius: 50%;
                }

                .avatar-placeholder {
                    width: 100%;
                    height: 100%;
                    background-color: #e6e8eb;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 20px;
                    color: #909399;
                }
            }
        }

        .students-count {
            margin-bottom: 10px;
            color: #666;
            
            i {
                margin-right: 5px;
            }
        }

        .advisers-section {
            margin: 15px 0;

            .section-title {
                margin-bottom: 5px;
                color: #303133;
                font-weight: normal;
            }

            .advisors-list {
                display: flex;
                flex-wrap: wrap;
                gap: 4px;

                .advisor {
                    display: inline-flex;
                }
            }
        }

        .status-section {
            display: flex;
            align-items: center;
        }

        .actions {
            margin-top: 15px;
            display: flex;
            justify-content: flex-end;
        }

        div:has(.status-section) {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .actions {
                margin-top: 0;
            }
        }
    }
}
</style> 